import { Toastr } from "../revvComponents";

import BaseCommand from "./baseCommand";
import { updateDocMetaService } from "../actions/DocumentActions/index";
import { DOCUMENTS } from "../constants";

const { DOCUMENT_MODE } = DOCUMENTS;
class UpdatePageNumberConfigCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  _getAction = () => {
    const { updateTemplateMetaAction, updateDocMetaAction, mode } =
      this.componentData;
    if (mode === DOCUMENT_MODE.DOCUMENT) return updateDocMetaAction;
    if (mode === DOCUMENT_MODE.TEMPLATE) return updateTemplateMetaAction;
    return () => {};
  };

  _updateMetaData = updatedMetaData => {
    const { mode, docID } = this.componentData;
    const data = [
      {
        op: "replace",
        field: "meta_data",
        value: { meta_data: { ...updatedMetaData } },
      },
    ];

    updateDocMetaService(mode)({ docId: docID, data })
      .then(response => {
        this._getAction()(response);
      })
      .catch(error => {
        console.error(`UpdatePageNumberConfigCommand => Error : ${error}`);
        Toastr.showToastr({
          type: "failure",
          message: "Oops, Something went wrong!!",
          timeout: 3000,
        });
      });
  };

  execute() {
    const { pageStart, pageEnd, oldMetaData } = this.componentData;
    const updatedMetaData = { ...oldMetaData, pageStart, pageEnd };
    this._updateMetaData(updatedMetaData);
  }

  undo() {
    const { oldMetaData } = this.componentData;
    this._updateMetaData(oldMetaData);
  }
}

export default UpdatePageNumberConfigCommand;
